import React, { Component } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import routes from "../../routes/URL";
import API, { URL_PATH } from "../../services/API";
import redux from "../../common/Redux";
import Table from "../../components/Table";
import Toast from "../../components/Toast";
import Header from "../../components/Header";
class ListCategoryScreen extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      data: [],
      toast: {
        open: false,
        message: "",
        severity: "success"
      }
     };
  }

  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity
      }
    });
  }
  
  handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      toast: {
        ...this.state.toast,
        open: false
      }
    });
  }
  
  
   componentDidMount() {
    // Check if hotel slug matches
    const hotel = this.props.hotels.find(h => h.hotel_slug === this.props.match.params.hotelSlug);
    if (!hotel) {
        this.props.history.push(routes.admin.dashboard.root(this.props.hotels[0]?.hotel_slug || ''));
        return;
    }
  }

  


  onDelete = async (item) => {
    console.log("sure to delete?");
    const { status, message, data } = await API(
      this,
      "post",
      URL_PATH.deleteCategory(item.id)
    );
    if (status == "success") {
      this.showToast(message, "success");
      this.setState({ version: this.state.version + 1 });
    } else {
      this.showToast(message, "error");
    }
  };


  onEdit = async (item) => {
    this.props.history.push(routes.admin.category.update(this.props.hotels[0].hotel_slug,item.slug,item.id));
  };
  onView = async (item) => {
    this.props.history.push(routes.admin.category.show(this.props.hotels[0].hotel_slug,item.slug,item.id));
  };
  onSwitch = async (item, value) => {
    console.log("Switch: ", item, value);
    const { status, message, data } = await API(
      this,
      "get",
      URL_PATH.updateCategoryStatus,
      { category_id: item.id, status: value }
    );
  };

  render() {
    return (
      <div className="container-fluid">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            alignContent: "center",
          }}
        >
              <Header title="Menu Categories" />

          <div>
            {/* <div
              className="btn btn-primary mr-2"
              style={{ fontWeight: "700"}}

              onClick={() => {
                this.props.history.push(routes.admin.menu.root);
                // location.history.push("/hotel/create");
              }}
            >
            <i className="fa fa-eye" aria-hidden="true"></i>  View Menu
            </div> */}

            <div 
              className="btn ml-2"
              style={{marginLeft:"5px",backgroundColor: "#FFC857", color: "#000", fontWeight: "700"}}

              onClick={() => {
                this.props.history.push(routes.admin.category.create(this.props.hotels[0].hotel_slug));
                // location.history.push("/hotel/create");
              }}
            >
             + New Category
            </div>
          </div>
        </div>

        <Toast
        open={this.state.toast.open}
        message={this.state.toast.message}
        severity={this.state.toast.severity}
        handleClose={this.handleCloseToast}
      />

        <Table
          key={this.state.version}
          api={URL_PATH.listCategory(this.props.selectedHotelId.id)}
          // onRowClick={this.onView}
          onEdit={this.onEdit}
          onView={this.onView}
          searchPlaceholder="Search by name"

          deleteText="delete all data related to this table."
          onDelete={this.onDelete}
          row={[
            {
              title: "Icon",
              key: "category_image",
              sortable: false,
              type: "icon",
            },
            {
              title: "Name",
              key: "category_name",
              sortable: true,
            },
            {
              title: "Menu Count",
              key: "hotel_menu_count",
              sortable: true,
            },
            {
              title: "Available",
              key: "status",
              sortable: true,
              type: "switch",
              onSwitch: this.onSwitch,
            },
            // {
            //     title: " Status",
            //     key: "table_status",
            //     sortable: true,
            // },
            // {
            //     title: "Capicity",
            //     key: "category_image",
            //     sortable: true,
            // },
          ]}
        />
      </div>
    );
  }
}

export default redux(ListCategoryScreen);
